// extracted by mini-css-extract-plugin
module.exports = {"lastUpdatedContainer":"LastUpdated_lastUpdatedContainer__2CClL","lastUpdatedWrapper":"LastUpdated_lastUpdatedWrapper__3hPJN","lastUpdatedIcon":"LastUpdated_lastUpdatedIcon__FeohI"};